import * as display from './display.js';
import { parse } from './csv-sync';

let store = { csv: [], urls: [] };

export function dataSave(store, url, data) {
  const found = findIndex(store, url);
  if (found < 0) {
    store.urls.push(url);
    store.csv.push(data);
  }
}

export function dataLoad(store, url) {
  const idx = findIndex(store, url);
  if (idx > -1) {
    return getDataByIndex(store, idx);
  } else {
    return null;
  }
}

export function findIndex(store, url) {
  return store.urls.indexOf(url);
}

export function getDataByIndex(store, idx) {
  return store.csv[idx];
}

export async function loadData(url) {
  // display.loading(true);
  let data = dataLoad(store, url);
  if (data == null) {
    // console.log('loading from Google sheet:', url);
    return fetch(url)
      .then((response) => { 
        // if (!response.ok) {
        //   throw new Error("Network response was not OK");
        // }
        return response.text()
      })
      .then((csv) => {
        const options = {};
        const data = parse(csv, options);
        // let data = parse(csv, options, (err, data) => {
        // });
        // console.log(data)
        // console.info(data);
        // display.loading(false);
        dataSave(store, url, data);
        return data;
      })
      .catch((error) => {
        console.error("There has been a problem with your fetch operation:", error);
      });
  } else {
    // display.loading(false);
    return data;
  }
}

export function googleTabUrl(monthTabIds, docId, monthNo) {
  return `https://docs.google.com/spreadsheets/d/e/${docId}/pub?gid=${
    monthTabIds[monthNo - 1]
  }&single=true&output=csv`;
}
